import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=08c47b3e&scoped=true&"
import script from "./TopicList.vue?vue&type=script&lang=js&"
export * from "./TopicList.vue?vue&type=script&lang=js&"
import style0 from "./TopicList.vue?vue&type=style&index=0&id=08c47b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c47b3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VTooltip})
